import React from 'react';
import AdminLayout from '../../layouts/AdminLayout';
import CalendarCore from '../../components/CalendarCore';

export default function CalendarPage() {
  return (
    <AdminLayout>
      <CalendarCore />
    </AdminLayout>
  );
}
